<template>
  <div class="help" tabindex="0" @keyup.esc="handleClosingModals">
    <div class="center">
      <div class="logo">
        <img src="@/assets/TPM_yourpath.svg" alt />
      </div>
      <div class="title">
        <h2 class="text-capitalize">{{ $t('help.title') }}</h2>
      </div>
      <div class="items row">
        <div class="col-12 col-md-6">
          <div v-if="!roles.includes('student')" class="item">
            <div class="item-icon">
              <img src="@/assets/help/garantia.png" alt />
            </div>
            <div class="item-title">
              <h2 @click="toggleWarrantyModal">{{ $t('help.warranty') }}</h2>
            </div>
          </div>
          <div v-if="!roles.includes('student')" class="item">
            <div class="item-icon">
              <img src="@/assets/help/email.png" alt />
            </div>
            <div class="item-title">
              <h2 @click="toggleContactModal">{{ $t('help.contact') }}</h2>
            </div>
          </div>
          <div v-if="!roles.includes('student')" class="item">
            <div class="item-icon">
              <img src="@/assets/help/manual.png" alt />
            </div>
            <div class="item-title">
              <h2 @click="toggleGuideModal">{{ $t('help.guide') }}</h2>
            </div>
          </div>
          <div v-if="!roles.includes('tutor')" class="item">
            <div class="item-icon">
              <img src="@/assets/help/demo.png" alt />
            </div>
            <div class="item-title">
              <h2 @click="toggleTutorTutorial">
                <i class="fa fa-play-circle"></i>
                {{ $t('help.demoTutor') }}
              </h2>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div v-if="!roles.includes('student')" class="item">
            <div class="item-icon">
              <img src="@/assets/help/suport.png" alt />
            </div>
            <div class="item-title">
              <h2 @click="toggleTechModal">{{ $t('help.support') }}</h2>
            </div>
          </div>
          <div v-if="!roles.includes('student')" class="item">
            <div class="item-icon">
              <img src="@/assets/help/demo.png" alt />
            </div>
            <div class="item-title">
              <h2 @click="toggleTutorTutorial">
                <i class="fa fa-play-circle"></i>
                {{ $t('help.demoTutor') }}
              </h2>
            </div>
          </div>
          <div class="item">
            <div class="item-icon">
              <img src="@/assets/help/demo.png" alt />
            </div>
            <div class="item-title">
              <h2 @click="toggleStudentTutorial">
                <i class="fa fa-play-circle"></i>
                {{ $t('help.demoStudent') }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tpm-modal :showhide="showWarranty">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleWarrantyModal">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
      </div>
      <div class="modal-body">
        <warranty></warranty>
      </div>
    </tpm-modal>
    <tpm-modal :showhide="showContact">
      <div class="modal-header">
         <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleContactModal">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
      </div>
      <div class="modal-body">
        <div class="logo-hmp">
          <img src="@/assets/HMP_COLOR.svg" alt />
        </div>
        <div class="header">
          <img src="@/assets/help/email.png" alt />
          {{ $t('help.contact') }}
        </div>
        <div class="contact-info">
          <p class="text-uppercase">{{ $t('help.contactInfo.hmp') }}</p>
          <p>{{ $t('help.contactInfo.address') }}</p>
          <p>{{ $t('help.contactInfo.phone') }}</p>
          <p>{{ $t('help.contactInfo.fax') }}</p>
          <p>{{ $t('help.contactInfo.web') }}</p>
          <p>{{ $t('help.contactInfo.cs') }}</p>
        </div>
      </div>
    </tpm-modal>
    <tpm-modal :showhide="showTechSupport">
      <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleTechModal">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
      </div>
      <div class="modal-body">
        <div class="logo-hmp">
          <img src="@/assets/HMP_COLOR.svg" alt />
        </div>
        <div class="header">
          <img src="@/assets/help/suport.png" alt />
          {{ $t('help.support') }}
        </div>
        <div class="contact-info">
          <p style="margin-bottom: 25px;">{{ $t('help.techSupportInfo.email') }}</p>
          <p>{{ $t('help.techSupportInfo.available') }}</p>
          <p>{{ $t('help.techSupportInfo.open') }}</p>
        </div>
      </div>
    </tpm-modal>
    <tpm-modal :showhide="showParentsGuide">
      <div class="modal-header">
         <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleGuideModal">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleGuideModal">
          <img src="@/assets/icons/exit1.png" class alt="Close" />
        </button> -->
      </div>
      <div class="modal-body">
        <div class="logo-hmp">
          <img src="@/assets/HMP_COLOR.svg" alt />
        </div>
        <div class="header">
          <img src="@/assets/help/manual.png" alt />
          {{ $t('help.guide') }}
        </div>
        <div class="manual-links">
          <a href="static/manual/ManualTPM.pdf" target="_blank" rel="noreferrer">
            <label>English</label>
            <img src="@/assets/flags/english.png" alt width="32" height="32" />
          </a>
          <a href="static/manual/ManualTPM-ESP.pdf" target="_blank" rel="noreferrer">
            <label>Español</label>
            <img src="@/assets/flags/spanish.png" alt width="32" height="32" />
          </a>
        </div>
      </div>
    </tpm-modal>
    <tpm-modal :showhide="showTutorTutorial">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleTutorTutorial">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
      </div>
      <div class="modal-body">
        <iframe
          v-if="showTutorTutorial && $store.state.language === 'en' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showTutorTutorial && $store.state.language === 'es' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showTutorTutorial && lang === 'en' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showTutorTutorial && lang === 'es' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>

        <div class="message-expand">
          <div class="body-message">
            <p>
              {{ $t('help.chooseVideo') }}
              <img src="@/assets/icons/expand-window.gif" />
              {{ $t('help.expandIcon') }}
            </p>
          </div>
        </div>
      </div>
    </tpm-modal>
    <tpm-modal :showhide="showStudentTutorial">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleStudentTutorial">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
      </div>
      <div class="modal-body">
        <iframe
          v-if="showStudentTutorial && $store.state.language === 'en' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showStudentTutorial && $store.state.language === 'es' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showStudentTutorial && lang === 'en' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showStudentTutorial && lang === 'es' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>

        <div class="message-expand">
          <div class="body-message">
            <p>
              {{ $t('help.chooseVideo') }}
              <img src="@/assets/icons/expand-window.gif" />
              {{ $t('help.expandIcon') }}
            </p>
          </div>
        </div>
      </div>
    </tpm-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Warranty from './components/Warranty.vue';
// const { ipcRenderer } = require('electron')
export default {
  name: 'Help',
  components: {
    warranty: Warranty,
  },
  data() {
    return {
      showWarranty: false,
      showContact: false,
      showTechSupport: false,
      showParentsGuide: false,
      showTutorTutorial: false,
      showStudentTutorial: false,
      tutorialsView: false,
      st: null,
    };
  },
  computed: {
    ...mapGetters({
      roles: 'auth/roles',
      lang: 'app/language', //for student
    }),
  },
  methods: {
    handleClosingModals() {
      // Disable active modal
      if (this.showWarranty) this.showWarranty = false;
      if (this.showContact) this.showContact = false;
      if (this.showTechSupport) this.showTechSupport = false;
      if (this.showParentsGuide) this.showParentsGuide = false;
      if (this.showTutorTutorial) this.showTutorTutorial = false;
      if (this.showStudentTutorial) this.showStudentTutorial = false;
      if (this.tutorialsView) this.tutorialsView = false;
    },
    toggleWarrantyModal() {
      this.setLargeModal();
      this.showWarranty = !this.showWarranty;
    },
    toggleContactModal() {
      this.setSmallModal();
      this.showContact = !this.showContact;
    },
    toggleTechModal() {
      this.setSmallModal();
      this.showTechSupport = !this.showTechSupport;
    },
    toggleGuideModal() {
      this.setSmallModal();
      this.showParentsGuide = !this.showParentsGuide;
    },
    toggleTutorTutorial() {
      this.setLargeModal();
      this.showTutorTutorial = !this.showTutorTutorial;
      this.tutorialsView = !this.tutorialsView;
      // this.expandNotification(0);
    },
    toggleStudentTutorial() {
      this.setLargeModal();
      this.showStudentTutorial = !this.showStudentTutorial;
      this.tutorialsView = !this.tutorialsView;
      // this.expandNotification(1);
    },
    setSmallModal() {
      var payload = {
        width: '500',
        prefixWidth: 'px',
        height: '500',
        prefixHeight: 'px',
      };
      this.$store.commit('SET_STYLE_MODAL', payload);
    },
    setLargeModal() {
      var payload = {
        width: '100',
        prefixWidth: 'vw',
        height: '90',
        prefixHeight: 'vh',
      };
      this.$store.commit('SET_STYLE_MODAL', payload);
    },
    setModalTutorial() {
      var payload = {
        width: '100',
        prefixWidth: 'vw',
        height: '100',
        prefixHeight: 'vh',
      };
      this.$store.commit('SET_STYLE_MODAL', payload);
    },
    /* expandNotification(type) {
      // 0.- Teacher || 1.- Student
      if (this.tutorialsView === true) {
        this.st = setTimeout(() => {
          document.getElementsByClassName('icon-expand-text')[type].style.visibility = 'hidden';
        }, 4000);
      } else {
        clearTimeout(this.st);
        document.getElementsByClassName('icon-expand-text')[type].style.visibility = 'visible';
      }
    }, */
  },
};
</script>
<style lang="scss" scoped>
.help {
  position: relative;
  //top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .center {
    margin-top: 90px;
  }
  .logo {
    margin: 25px auto;
    display: flex;
    justify-content: center;
    img {
      height: 150px;
      width: 225px;
    }
  }
  .title {
    display: flex;
    justify-content: center;
    h2 {
      font-family: 'comfortaabold';
      font-size: 60px;
      color: #409da4;
    }
  }
  .items {
    .item {
      margin: 10px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .item-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 60px;
        background-color: #ced529;
        border-radius: 30px 0 0 30px;
        img {
          margin-left: 5px;
          height: 35px;
          width: 35px;
        }
      }
      .item-title {
        height: 40px;
        width: 100%;
        background-color: rgba(206, 213, 41, 0.35);
        border: 2px solid #ced529;
        border-left: 0;
        border-radius: 0 20px 20px 0;
        display: flex;
        align-items: center;
        h2 {
          color: #1b5b60;
          margin: 0 10px;
          line-height: 1;
          font-size: 19px;
          font-family: 'comfortaaregular';
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.modal-header {
  background-color: #cdd528;
  border: none;
  .close {
    position: absolute;
    top: 0px;
    right: 20px;
    opacity: 1;
    img {
      width: 30px;
    }
    &:focus {
      outline: none;
    }
  }
}
.modal-body {
  height: 100%;
  padding: 0;
  border-left: 5px solid #cdd528;
  border-right: 5px solid #cdd528;
  border-bottom: 25px solid #cdd528;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  line-height: 22px;
  overflow-y: scroll;
}
.logo-hmp {
  text-align: center;
  img {
    padding: 10px;
    height: 150px;
  }
}
.header {
  display: inline-block;
  width: auto;
  height: 50px;
  padding: 14px 20px 0;
  color: #fff;
  font-family: 'comfortaabold';
  font-size: 26px;
  background-color: #cdd528;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  img {
    margin-top: -8px;
    margin-right: 10px;
    height: 34px;
    vertical-align: middle;
  }
}
.contact-info {
  padding: 20px;
  color: #4ea8b4;
  font-size: 20px;
  p {
    margin-bottom: 10px;
  }
}
.manual-links {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: #000;
    label {
      margin: 0;
      padding-bottom: 0.5rem;
      font-family: 'comfortaabold';
      cursor: pointer;
    }
    img {
      cursor: pointer;
    }
  }
}
.tutorial {
  width: 100%;
  height: 100%;
}

//landscape phone
@media (max-height: 350px) {
  .tutorial {
    height: 70%;
  }
}
@media (max-width: 576px) {
  .modal-body {
    height: unset;
  }
}
@include forTablet() {
  .items {
    display: flex;
  }
  .modal-body {
    height: unset;
  }
}
@include forDesktop() {
  .help .center {
    width: 50%;
  }
}

.message-expand {
  width: 100%;
  height: auto;
  font-size: 20px;
  margin-bottom: 20px;
}

.message-expand > .body-message {
  text-align: center;
}

.message-expand > .body-message > p > img {
  max-width: 30px;
  vertical-align: bottom;
}
</style>
